import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { Session } from './utils/session'; 
function formatDate(dateString) {
  if (!dateString) return '';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return dateString;
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/* ========= AUTH HEADER ========= */
const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${Session.getToken()}`
});

export default function ActivityTable({ mode, WorkspaceID, employeeName, selectedDate }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        const endpoint = mode === 'daily' ? 'daily' : 'weekly';
        let url = `${API_BASE_URL}/api/UserActivityReport/${endpoint}`;
        const params = new URLSearchParams();

        if (WorkspaceID) params.append('workspaceId', WorkspaceID);
        if (employeeName?.trim()) params.append('employeeName', employeeName.trim());

        if (selectedDate) {
          if (mode === 'daily') {
            params.append('date', selectedDate);
          } else {
            params.append('fromDate', selectedDate);
            params.append('toDate', selectedDate);
          }
        }

        if ([...params].length > 0) {
          url += `?${params.toString()}`;
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: authHeaders(),          // ✅ FIX HERE
          signal: controller.signal
        });

        if (response.status === 401) {
          throw new Error('Unauthorized (401)');
        }

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        setRows(data || []);
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error(err);
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };
    loadData();
    return () => controller.abort();
  }, [mode, WorkspaceID, employeeName, selectedDate]);

  if (loading) {
    return (
      <div className="table-responsive">
        <div className="p-3 text-center text-muted">Loading activity...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="table-responsive">
        <div className="p-3 text-center text-danger">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-custom table-hover">
        <thead>
          <tr>
            <th>Date</th>
            <th>Member</th>
            <th>Teams</th>
            <th>Total time</th>
            <th>Productive</th>
            <th>Neutral</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={7} className="text-center text-muted py-3">No records found.</td>
            </tr>
          )}
          {rows.map((r) => (
            <tr key={`${r.userId}-${r.workDate}-${r.workspaceID ?? 'na'}`}>
              <td className="text-muted">{formatDate(r.workDate)}</td>
              <td>
                <div className="employee-info">
                  {/* <img src={`/Images/user.png"u=${r.userId}`} className="avatar" alt={r.userName} /> */}
                  <img
  src={`/Images/user.png?u=${r.userId}`}
  alt={r.userName}
  className="rounded-circle"
  style={{ width: "24px", height: "24px" }}
/>
                  <div className="emp-text">
                    <h6>{r.userName}</h6>
                    <span>User ID: {r.userId}</span>
                  </div>
                </div>
              </td>
            <td>
  {r.workspaceName
    ? r.workspaceName.split(',').map((name, index) => (
        <span key={index} className="tag me-1">
          {name.trim()}
        </span>
      ))
    : <span className="tag">Unassigned</span>
  }
</td>
              <td>{r.totalTime}</td>
               <td><div className="text-green">{r.productive}</div></td>
              <td><div className="text-neutral">{r.neutral}</div></td>
              <td>
                <i
                  className="far fa-eye text-muted"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    navigate(`/ViewActivityHistory/${r.userId}`, {
                      state: { totalTime: r.totalTime, workDate: r.workDate },
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
